  const style = document.createElement('style');
  style.setAttribute("one-gift", "")
  style.innerHTML = `
        #slidecarthq .slick-slide.slick-active.slick-current {
          width: 353px !important;
        }
        #slidecarthq .free-gifts-item {
          flex-direction: row;
        }
        #slidecarthq .free-gifts-item-media, #slidecarthq .free-gifts-item-body{
          flex: 1;
          padding: 5px !important;
        }
        #slidecarthq .free-gifts-item-footer {
          margin-top: 0px !important;
          padding-top: 0px !important;
        }
        @media screen and (max-width: 480px) {
          #slidecarthq .upsell-text-prices {
            gap: 30px;
          }
          #slidecarthq .free-gifts {
            padding: 20px 0 !important;
            width: 100% !important;
          }
          #slidecarthq .free-gifts-item {
            width: 100%;
            padding: 0 !important; 
            margin: 0 10px !important;
          }
          #slidecarthq .slick-wrapper {
            padding: 0 !important; 
          }
        }
        #slidecarthq .free-gifts-item-media {
          padding: 5px;
        }
      `;

  function placingPriceOnButton() {
    try {
      const subtotalEl = document.querySelector('.slidecarthq strong.slidecart-subtotal');
      if (!subtotalEl) {
        console.warn('Subtotal element not found.');
        return;
      }

      const subtotal = subtotalEl.innerText;
      const existingSubtotal = document.querySelector('.slidecarthq form#slidecart-checkout-form button.button .subtotalOnButton');
      if (existingSubtotal) {
        existingSubtotal.remove();
      }

      const subtotalPrice = document.createElement('span');
      subtotalPrice.classList.add('subtotalOnButton');
      subtotalPrice.innerText = ' • ' + subtotal;

      const checkoutButton = document.querySelector('.slidecarthq form#slidecart-checkout-form button.button');
      if (!checkoutButton) {
        console.warn('Checkout button not found.');
        return;
      }

      checkoutButton.appendChild(subtotalPrice);
    } catch (error) {
      console.error('Error in placingPriceOnButton:', error);
    }
  }

  function scSyncCartCounts(count) {
    const slideCartCount = document.querySelector('#slidecarthq header .cart-count');
    if (slideCartCount) {
      slideCartCount.textContent = count;
    }

    const headerCartCount = document.querySelector('.site-header-cart--count');
    if (headerCartCount) {
      headerCartCount.setAttribute('data-header-cart-count', `${count}`);

      if (count > 0) {
        headerCartCount.classList.add('visible');
      } else {
        headerCartCount.classList.remove('visible');
      }
    }
  }

  function scToggleGiftStyle() {
    const freeGifts = document.querySelectorAll("#slidecarthq .free-gifts-item");

    if (freeGifts.length > 1) {
      const giftStyle = document.querySelector("style[one-gift]");

      if (giftStyle) {
        giftStyle.remove();
      }
    } else {
      document.head.appendChild(style);
    }
  }

  async function fixMissingImages() {
    const items = document.querySelectorAll('#slidecarthq .items img');

    items.forEach(async (img) => {
      if (img.naturalHeight !== 0) return;

      try {
        const url = new URL(img.closest('a').href);
        const handle = url.pathname.split('/products/')[1];
        const variantId = parseInt(url.searchParams.get('variant'));

        const res = await fetch(`${window.Shopify.routes.root}products/${handle}.js`);
        const product = await res.json();

        const variant = product.variants.find(v => v.id === variantId);
        let src = variant?.featured_image?.src || product.featured_image;

        if (src) {
          const dot = src.lastIndexOf('.');
          img.src = src.substring(0, dot) + '_160x' + src.substring(dot);
        }
      } catch (e) {}
    });
  }


  document.addEventListener(
    "mouseup",
    function (event) {
      if (event.target.matches('.snize-add-to-cart-button, .snize-add-to-cart-button *')) {
        try {
          if (window.SLIDECART_STATE().settings.enabled) {
            setTimeout(function () {
              window.SLIDECART_UPDATE();
              window.SLIDECART_OPEN();
            }, 600);

            setTimeout(function () {
              window.SLIDECART_UPDATE();
            }, 1200);
          }
        } catch (err) {
        }
      }
    },
    false
  );


  window.SLIDECART_LOADED = cart => {
    // Only run once after a short delay
    setTimeout(function () {
      const btn = document.querySelectorAll("#slidecarthq .upsell-add button");
      btn.forEach(b => {
        if (b.childNodes[1]) {
          b.childNodes[1].textContent = "Add to cart";
        }
      });
    }, 500);

    // re-enable atc and header cart icon buttons
    document.querySelector('body').classList.remove('slide-cart-loading');
  }

  window.SLIDECART_UPDATED = cart => {
    placingPriceOnButton();
    scSyncCartCounts(cart.item_count);
    setTimeout(scToggleGiftStyle, 1000);
    fixMissingImages();
  } 